import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowUpward } from "@mui/icons-material";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { useCompany } from "../../hooks/useCompany";
import { CompanyStatus } from "../../types/company";
import { formatMoney } from "../../utils/helper";
import { CardBase } from "../global";

interface BalanceCardProps {
    onTopUpClick: () => void;
}

const BalanceCard = ({ onTopUpClick }: BalanceCardProps) => {
    const user = useCurrentUser();
    const company = useCompany();
    const navigate = useNavigate();

    return (
        <CardBase
            useGlassCard={true}
            nested={false}
            actions={
                <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", p: 2 }}>
                    <Button onClick={() => navigate(`/finances/invoices`)}>
                        Invoice History
                    </Button>
                    <Button
                        onClick={onTopUpClick}
                        variant="contained"
                        disabled={company?.status != CompanyStatus.ACTIVE}
                        startIcon={<ArrowUpward />}
                    >
                        Top Up
                    </Button>
                </Box>
            }
        >
            <Box sx={{ p: 2 }}>
                <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                >
                    Current Balance
                </Typography>
                <Typography variant="h4" component="div">
                    {`$${formatMoney(user?.company?.balance_decrypt || 0)}`}
                </Typography>
            </Box>
        </CardBase>
    );
};

export default BalanceCard;

